import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaYoutube } from "react-icons/fa";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <div className="img-container" style={{ position: "relative", overflow: "hidden" }}>
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <div className="card-img-overlay"></div>
      </div>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>
          {props.description}
        </Card.Text>
        <div className="d-flex flex-wrap mt-auto">
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> GitHub
            </Button>
          )}
          {props.ytLink && (
            <Button variant="danger" href={props.ytLink} target="_blank">
              <FaYoutube /> YouTube
            </Button>
          )}
          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
            >
              <CgWebsite /> Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
